import { Lightning, Truck, Warehouse } from 'shared/icons';

// Modalidade do envio independente do canal. Novos canais continuam usando
// CHANNEL_META/ChannelLogo; novos tipos de logística entram neste catálogo.
export const ORDER_LOGISTICS = {
    fulfillment: {
        label: 'Full',
        description: 'Enviado pelo centro de distribuição do Mercado Livre',
        Icon: Warehouse,
        tone: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-400/10 dark:text-emerald-300',
    },
    self_service: {
        label: 'Flex · envio próprio',
        description: 'Entrega própria / Mercado Envios Flex',
        Icon: Lightning,
        tone: 'bg-sky-50 text-sky-700 dark:bg-sky-400/10 dark:text-sky-300',
    },
    cross_docking: {
        label: 'Coleta / Cross',
        description: 'Coletado pelo Mercado Livre (cross docking)',
        Icon: Truck,
        tone: 'bg-amber-50 text-amber-700 dark:bg-amber-400/10 dark:text-amber-300',
    },
};
